import { gql } from '@biletiniz/apollo';

export const FLIGHT_BOOKING_INFO_QUERY = gql`
  query GetBookingInfo($session: String!) {
    flightBookingInfo(session: $session) {
      providerType
      providerContext {
        surname
        givenName
        totalPrice
        totalFee
        currency
        pnr
      }
      id
      session
      telephone
      email
      passengers {
        passengerTypeCode
        tc
        gender
        passportNo
        mileNumber
        givenName
        surname
        hesCode
        birthDate
        namePrefix
        tcdegil
        passportCountry
        passportExpirationDate
        nationality
      }

      paymentCard {
        cardHolderName
        cardNumber
        cvc
        expireYear
        expireMonth
      }
      packagesCode
      pnr
      isReservationPurchase
    }
  }
`;
